<template>
  <div>
    <section class="py-5">
      <div class="container-fluid">
        <div v-if="routeName !== '/'" class="col-12 sliderDetails">
          <p class="movieCat">
            SPECIAL SCREENINGS
            <span class="txt-link">
              <router-link class="ml-4 mr-2" to>Watch Movies on Demand</router-link>
              <!-- <img id="tooltip-2" src="@/assets/img/svg/info-rd-icon.svg" class="rounded-circle" /> -->
              <!-- <button class="btn btn-danger viewmore-btn mr-4" @click="showModal = true">Know more</button> -->
              <b-modal v-model="showModal" ok-variant="danger" >
                <ul>
                  <li>Select the favorite movie you want to watch by clicking on the movie image.</li>
                  <li>
                    These movies are special screening created exclusively for fans like you to
                    enjoy.
                  </li>
                  <li>Join the screening by completing the booking process.</li>
                  <li>Enjoy Exclusive screening of your favorite movie.</li>
                </ul>
    </b-modal>
              <!-- ToolTip -->
              <b-tooltip target="tooltip-2" placement="right">
                
              </b-tooltip>
            </span>
            <!-- <span class="link ml-2"><router-link :to="{ name: 'nowShowingList'}">(See All)</router-link></span> -->
          </p>
        </div>
        <div class="row">
          <div
            class="col-6 col-md-4 col-lg-3 col-xl-2 mb-4"
            v-for="(singleMovie, singleMovieIndex) in OwnScreening"
            :key="singleMovieIndex"
          >
            <div class="movieSlider-container mx-auto text-center">
              <div class="img-container">
                <router-link
                  :to="{ name: 'createScreen', params: { movieId: singleMovie.ID,categoryId: 2 }}"
                >
                  <img :src="singleMovie.Image" alt class="img-fluid mx-auto banner" />
                </router-link>

                <!-- <div class="img-logo">
                    <router-link :to="{ name: 'regularMovies', params: { movieId: singleMovie.ID,categoryId: 1 }}"><img src="@/assets/img/svg/gogo-small-icon.svg" class="img-fluid"></router-link>
                </div>-->
              </div>
              <div class="text-center mx-auto pt-2 pt-md-3 movieSliderInfo">
                <p class="mb-0 title">{{singleMovie.Name}}</p>
                <ul class="list-inline mb-0 mInfo">
                  <li class="list-inline-item">{{singleMovie.Year}}</li>
                  <li class="list-inline-item">|</li>
                  <li class="list-inline-item">{{singleMovie.Rated}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- SPECIAL SCREENINGS MOVIES SLIDER -->
    <section class="bg-light py-2">
      <div class="container-fluid my-4">
        <UpcomingFestivals />
      </div>
    </section>
  </div>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";

//   import NowShowing from "@/components/partials/nowShowingSlider.vue";
import SpecialScreenings from "@/components/partials/SpecialScreeningsSlider.vue";
import OwnScreeningSlider from "@/components/partials/OwnScreeningSlider.vue";
import UpcomingFestivals from "@/components/partials/UpcomingMiniFestivals.vue";

export default {
  name: "searchResult",
  directives: {
    // 'dragscroll': dragscroll
  },
  components: {
    Slick,
    OwnScreeningSlider,
    UpcomingFestivals
  },

  data() {
    return {
      showModal: false,
      dateTimeSlider: {
        dots: false,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 9,
        slidesToScroll: 6,
        dots: false,
        responsive: [
          {
            breakpoint: 1900,
            settings: {
              slidesToShow: 7,
              slidesToScroll: 4,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3.1,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2
            }
          }
        ]
      },
      movieSlider: {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5.5,
        slidesToScroll: 4,
        dots: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3.5,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      },
      OwnScreening: []
    };
  },
  mounted() {
    // this.getNowShowingData();
  },
  methods: {
    getNowShowingData: function() {
      makeRequest("/GetAllShow/", "POST", null, null)
        .then(response => {
          const { error, res } = response;
          this.OwnScreening = res.data.shows[1].Movies;
        })
        .catch(error => {
          console.log("Error", error);
        });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pages/specialScreeningList.vue